import React, { useState } from 'react';

const REACTIONS = [
  { type: 'like',  emoji: '👍', label: 'Like' },
  { type: 'love',  emoji: '❤️', label: 'Love' },
  { type: 'care',  emoji: '🤗', label: 'Care' },
  { type: 'sad',   emoji: '😢', label: 'Sad' },
];

/**
 * Facebook-style reaction bar — Jenn/Patti, 2026-09-06: real screenshot of
 * My Hive showed no way to react to a post at all. Click your own current
 * reaction again to remove it.
 */
export default function ReactionBar({ reactions, onReact }) {
  const [picking, setPicking] = useState(false);
  const counts = reactions?.counts || {};
  const mine = reactions?.mine || null;
  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  const handlePick = (type) => {
    setPicking(false);
    onReact(type);
  };

  return (
    <div className="relative inline-flex items-center gap-2">
      <button
        type="button"
        onClick={() => (mine ? handlePick(mine) : setPicking(v => !v))}
        onMouseEnter={() => setPicking(true)}
        className={`text-xs font-medium px-2 py-1 rounded-lg transition-colors ${
          mine ? 'bg-reset-terracotta/10 text-reset-terracotta' : 'text-gray-500 hover:bg-reset-creamDark'
        }`}
      >
        {mine ? REACTIONS.find(r => r.type === mine)?.emoji : '🤍'} {mine ? REACTIONS.find(r => r.type === mine)?.label : 'React'}
      </button>

      {total > 0 && (
        <span className="text-xs text-gray-400">
          {Object.entries(counts).map(([type, n]) => `${REACTIONS.find(r => r.type === type)?.emoji}${n}`).join(' ')}
        </span>
      )}

      {picking && (
        <div
          onMouseLeave={() => setPicking(false)}
          className="absolute bottom-full left-0 mb-1 flex gap-1 bg-white rounded-full shadow-lg border border-gray-100 px-2 py-1.5 z-10"
        >
          {REACTIONS.map(r => (
            <button
              key={r.type}
              type="button"
              onClick={() => handlePick(r.type)}
              title={r.label}
              className={`text-lg leading-none p-1 rounded-full hover:scale-125 transition-transform ${mine === r.type ? 'bg-reset-terracotta/10' : ''}`}
            >
              {r.emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
